var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;}.b{stroke:none;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 10.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 10,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(8 3.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 18,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 17,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(16 -0.032)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 22,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 21,
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.cdeeadac4c20632f2ddc598c18f58fe6.svg";
export { ForwardRef as ReactComponent };